import { render, staticRenderFns } from "./CardAddElementFromLibraryAction.vue?vue&type=template&id=4b13cbc5"
import script from "./CardAddElementFromLibraryAction.vue?vue&type=script&lang=js"
export * from "./CardAddElementFromLibraryAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports